import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRough2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm1.39 3-9 12.5L15 40h18l6.5-12.227L26 8z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "m9.757 28.04 24.464-10.462.393.92L10.15 28.96z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M12.919 12.158 23.38 22.81l-.713.7-10.463-10.65z"
		})
	]
});
export default SvgRough2;
